'use client';

import { FC } from 'react';

import styled from 'styled-components';

import { useHybrisInfo } from '../../hooks/useHybrisInfo';
import { useNextJsInfo } from '../../hooks/useNextJsInfo';

const BranchInfoFooterWrapper = styled.div`
    word-break: break-word;
`;

export const BranchInfoFooter: FC = () => {
    const isSystemInfoEnabled = process.env.HYBRIS_PUBLIC_URL !== 'https://www.telia.lt';

    const nextJsBaseUrl = process.env.AWS_INSTANCE_NAME
        ? `https://${process.env.AWS_INSTANCE_NAME}.test-my.telia.lt`
        : '/';

    const systemInfo = useHybrisInfo(isSystemInfoEnabled);
    const nextJsInfo = useNextJsInfo(isSystemInfoEnabled, nextJsBaseUrl);

    if (!isSystemInfoEnabled) {
        return null;
    }

    return (
        <BranchInfoFooterWrapper>
            <br />
            <center>
                <h3>Next.js branch info</h3>
            </center>
            {process.env.GIT_BRANCH && (
                <center>
                    FE Git Branch:{' '}
                    <a
                        target="_blank"
                        href={`https://github.com/telia-company/lt-telia-web-apps/tree/${process.env.GIT_BRANCH}`}
                        rel="noreferrer"
                    >
                        <b>{process.env.GIT_BRANCH}</b>
                    </a>
                </center>
            )}
            {process.env.GIT_HASH && (
                <center>
                    FE Git Commit:{' '}
                    <a
                        target="_blank"
                        href={`https://github.com/telia-company/lt-telia-web-apps/commits/${process.env.GIT_HASH}`}
                        rel="noreferrer"
                    >
                        <b>{process.env.GIT_HASH}</b>
                    </a>
                </center>
            )}
            <center>
                <h3>Next.js environment info</h3>
            </center>
            {nextJsInfo?.hybrisPublicUrl && (
                <center>
                    Hybris public URL: <b>{nextJsInfo.hybrisPublicUrl}</b>
                </center>
            )}
            {nextJsInfo?.hybrisInternalUrl && (
                <center>
                    Hybris internal URL: <b>{nextJsInfo.hybrisInternalUrl}</b>
                </center>
            )}
            {nextJsInfo?.hudsonPublicUrl && (
                <center>
                    Hudson public URL: <b>{nextJsInfo.hudsonPublicUrl}</b>
                </center>
            )}
            {process.env.AWS_INSTANCE_NAME && (
                <center>
                    AWS environment:{' '}
                    <a
                        target="_blank"
                        href={`https://${process.env.AWS_INSTANCE_NAME}.test-my.telia.lt/api/info`}
                        rel="noreferrer"
                    >
                        <b>https://{process.env.AWS_INSTANCE_NAME}.test-my.telia.lt</b>
                    </a>
                </center>
            )}
            {nextJsInfo?.build && (
                <center>
                    Build: <b>{Math.round((nextJsInfo.build / 60 / 60) * 100) / 100} h</b>
                </center>
            )}
            {nextJsInfo?.uptime && (
                <center>
                    Uptime: <b>{Math.round((nextJsInfo.uptime / 60 / 60) * 100) / 100} h</b>
                </center>
            )}
            <center>
                <h3>Hybris branch info</h3>
            </center>
            <center>
                Current branch: <b>{systemInfo?.branchInfo}</b>
            </center>
            <center>
                Current node: <b>{systemInfo?.nodeInfo}</b>
            </center>
            <center>
                Current commit id: <b>{systemInfo?.commitId}</b>
            </center>
            <center>
                Build time: <b>{systemInfo?.nodeBuildTime}</b>
            </center>
            <center>
                Current FE branch:{' '}
                <a
                    target="_blank"
                    href={`https://github.com/telia-company/lt-telia-web-apps/tree/${systemInfo?.frontBranchInfo}`}
                    rel="noreferrer"
                >
                    <b>{systemInfo?.frontBranchInfo}</b>
                </a>
            </center>
            <center>
                Current FE commit id: <b>{systemInfo?.frontBaseCommitId}</b>
                {systemInfo?.frontOtherCommitId}
            </center>
            <br />
        </BranchInfoFooterWrapper>
    );
};
